import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import {
  MAIN_IMAGE_BORDER_RADIUS_L,
  MAIN_IMAGE_BORDER_RADIUS_M,
} from 'src/components/organisms/ProductImagesCarousel/ProductImagesCarousel.styles';

const { fonts, responsiveText, spacing } = theme;

export const root = css`
  margin: 0 -${spacing.md}px;
  padding: ${spacing.xs}px;
  text-align: center;
  ${responsiveText.BODY.XS};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 0;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.M, max: maxBreakpoints.M },
    css`
      border-bottom-left-radius: ${MAIN_IMAGE_BORDER_RADIUS_M}px;
      border-bottom-right-radius: ${MAIN_IMAGE_BORDER_RADIUS_M}px;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      border-bottom-left-radius: ${MAIN_IMAGE_BORDER_RADIUS_L}px;
      border-bottom-right-radius: ${MAIN_IMAGE_BORDER_RADIUS_L}px;
    `,
  )}
  
  svg {
    margin-right: ${spacing.base}px;
  }
`;

export const grey = css`
  background-color: var(--neutral-black-10);
  color: var(--neutral-black-70);
`;

export const red = css`
  background-color: var(--functional-red-10);
  color: var(--functional-red-base);
`;

export const green = css`
  background-color: var(--functional-green-10);
  color: var(--functional-green-deep);
`;

export const purple = css`
  background-color: var(--brand-purple-10);
  color: var(--brand-bluple-base);
`;
